const baseStyle = {}

const defaultProps = {}

const sizes = {}

const variants = {}

export default {
  baseStyle,
  defaultProps,
  sizes,
  variants,
}
